import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '../lib/utils';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
  variant?: 'naranja' | 'azul' | 'plata';
};
export const CHECKOUT_URL = 'https://neuro-running-pack.impultienda.ar/checkout';
export function CTAButton({
  children,
  className = '',
  href = CHECKOUT_URL,
  size = 'lg',
  variant = 'naranja'
}: Props) {
  const pad = size === 'lg' ? 'min-h-[65px] px-8 py-4 text-[18px]' : 'min-h-[58px] px-6 py-3.5 text-base';
  const skins = {
    naranja: 'bg-naranja text-ink shadow-[0_10px_40px_-8px_rgba(255,122,26,0.8)] ring-1 ring-naranja-soft/60 hover:bg-naranja-soft hover:shadow-[0_16px_50px_-8px_rgba(255,122,26,0.95)] focus-visible:ring-azul-soft',
    azul: 'bg-azul text-white shadow-[0_10px_40px_-8px_rgba(31,155,255,0.8)] ring-1 ring-azul-soft/60 hover:bg-azul-deep hover:shadow-[0_16px_50px_-8px_rgba(31,155,255,0.95)] focus-visible:ring-naranja',
    plata: 'bg-plata text-ink shadow-[0_10px_40px_-8px_rgba(201,211,224,0.45)] ring-1 ring-plata-soft/70 hover:bg-plata-soft focus-visible:ring-azul'
  } as const;
  return <a href={href} className={cn('group inline-flex w-full max-w-[340px] items-center justify-center gap-2 rounded-xl text-center font-extrabold uppercase leading-tight tracking-wide transition-[transform,background-color,box-shadow] duration-200 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2', skins[variant], pad, className)} style={{
    color: "#03060D",
    backgroundColor: "#7FD4FF"
  }} data-id="element-53" data-mp="1i9urdzfie3qv">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-54" data-mp="211422c10myk1" />
    </a>;
}